export function getInitials(
  firstName: string | undefined,
  lastName: string | undefined,
  reverseOrder: boolean | undefined
) {
  if (!firstName && !lastName) {
    return undefined;
  }
  let name: string;
  if (reverseOrder) {
    name = `${lastName?.[0] ?? ""}${firstName?.[0] ?? ""}`;
  } else {
    name = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`;
  }

  return name.toUpperCase();
}
